import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// 接收 isScrolled 属性
const NavLinks = ({ isScrolled }) => {
    // 根据滚动状态决定文字颜色
    const textColorClass = isScrolled ? 'text-gray-800 hover:text-blue-600' : 'text-white hover:text-blue-200';
    const buttonClass = isScrolled
        ? 'bg-blue-900 hover:bg-blue-800 text-white'
        : 'bg-white hover:bg-blue-50 text-blue-900';

    return (
        <div className="flex items-center">
            <Link
                className={`px-4 font-extrabold transition-colors duration-300 ${textColorClass}`}
                to="/about"
            >
                关于我们
            </Link>
            <Link
                className={`px-4 font-extrabold transition-colors duration-300 ${textColorClass}`}
                to="/app"
            >
                族语APP
            </Link>
            <HashLink
                className={`px-4 font-extrabold transition-colors duration-300 ${textColorClass}`}
                smooth to="/#portfolio"
            >
                产品故事
            </HashLink>
            <Link
                className={`px-4 font-extrabold transition-colors duration-300 ${textColorClass}`}
                to="/news"
            >
                新闻动态
            </Link>
            <HashLink
                className={`inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl transition-colors duration-300 ml-2 ${buttonClass}`}
                smooth to="/#contact"
            >
                联系我们
            </HashLink>
        </div>
    )
}

export default NavLinks;